var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Runner } from "../../framework/Runner";
import { setupBingAerialImagery } from "../index";
import { buildOrbitTrack } from "./buildOrbitTrack";
/**
 * General purpose 'flyover' runner that will load a kml and move the camera over the scene following the given
 * sequence of waypoints.
 *
 * @param config
 * @param desc
 * @param modifyObject
 * @param additionalTracks Additional animation tracks
 * @param endWait The length of time to wait after completing the full path
 */
export function kmlFlyover(config, desc, modifyObject, additionalTracks = () => {
    return [];
}, endWait = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        yield Runner.run(config, (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            setupBingAerialImagery(renderer);
            const labelFont = yield renderer.createFontAsset({
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/fonts/Roboto/Roboto-Black.ttf",
            });
            // Inject the labelFont field
            const finalDesc = Object.assign(Object.assign({}, desc), { labelFont });
            // Create the KML and give the modification callback its chance to alter the object
            const kml = yield renderer.getObjectFactory().createKml(finalDesc);
            renderer.getWorld().addObject(kml);
            if (modifyObject)
                yield modifyObject(kml);
            const { pTrack, rTrack } = buildOrbitTrack(kml, camera, endWait);
            const out = [pTrack, rTrack];
            out.push(...additionalTracks());
            return out;
        }));
    });
}
